import api from '../../api'
import getConfig from '../../../config'
import { getToken } from '../../../utils/session'
const { REACT_APP_API_BASE_URI } = getConfig()

export async function getSnapshot (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    responseFormat: 'object',
    url: '/market-data/moon-overnight/snapshot/current',
    params
  })
  return response.data
}

export async function getMostActive (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    responseFormat: 'records',
    url: '/market-data/moon-overnight/active/current',
    params
  })
  return response.data
}

export async function downloadMostActive (params) {
  const url = '/otcapi/download/internal/market-data/moon-overnight/active/current/download'
  const queryString = Object.keys(params)
    .filter(key => params[key])
    .map(key => params[key] && `${key}=${params[key]}`).join('&')
  let jwtToken
  await getToken()
    .then(res => {
      jwtToken = res
    })
  window.open(`${REACT_APP_API_BASE_URI}${url}?${queryString}&file=market-data-overnight-active&token=${jwtToken}`)
}

export async function getAdvancers (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    responseFormat: 'records',
    url: '/market-data/moon-overnight/advancers/current',
    params
  })
  return response.data
}

export async function downloadAdvancers (params) {
  const url = '/otcapi/download/internal/market-data/moon-overnight/advancers/current/download'
  const queryString = Object.keys(params)
    .filter(key => params[key])
    .map(key => params[key] && `${key}=${params[key]}`).join('&')
  let jwtToken
  await getToken()
    .then(res => {
      jwtToken = res
    })
  window.open(`${REACT_APP_API_BASE_URI}${url}?${queryString}&file=market-data-moon-overnight-advancers&token=${jwtToken}`)
}

export async function getDecliners (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    responseFormat: 'records',
    url: '/market-data/moon-overnight/decliners/current',
    params
  })
  return response.data
}

export async function downloadDecliners (params) {
  const url = '/otcapi/download/internal/market-data/moon-overnight/decliners/current/download'
  const queryString = Object.keys(params)
    .filter(key => params[key])
    .map(key => params[key] && `${key}=${params[key]}`).join('&')
  let jwtToken
  await getToken()
    .then(res => {
      jwtToken = res
    })
  window.open(`${REACT_APP_API_BASE_URI}${url}?${queryString}&file=market-data-moon-overnight-decliners&token=${jwtToken}`)
}
